import React from 'react'
import { AccountJoinForm } from './AccountJoinForm'
import { AccountJoinContainer } from './AccountJoinContainer'

export const AccountJoin = () => {
  return (
    <AccountJoinContainer
      title="Join first to start using the application"
      description={
        <>
          <p>
            You need to join specific organization first before you can use this application. You will need the organization code that can be provided
            by your organization head. Please contact them about it.
          </p>

          <p>
            But if you are brave enough to explore the wild you can use <strong>DFT</strong> as the organization code and just wait for the admin to
            accept your request.
          </p>
        </>
      }
    >
      <AccountJoinForm />
    </AccountJoinContainer>
  )
}
